import styled, { css } from "styled-components";

import { ReactComponent as AnglesLeftIcon } from "../../assets/angles-left.svg";
import { ReactComponent as AnglesRightIcon } from "../../assets/angles-right.svg";
import { ReactComponent as ArrowRightIcon } from "../../assets/arrow-right.svg";
import { ReactComponent as BalloonIcon } from "../../assets/balloon.svg";
import { ReactComponent as CalendarIcon } from "../../assets/calendar.svg";
import { ReactComponent as CameraIcon } from "../../assets/camera.svg";
import { ReactComponent as CarretLeftIcon } from "../../assets/carretleft.svg";
import { ReactComponent as CarretRightIcon } from "../../assets/carretright.svg";
import { ReactComponent as CheckIcon } from "../../assets/check.svg";
import { ReactComponent as CrossIcon } from "../../assets/cross.svg";
import { ReactComponent as DotIcon } from "../../assets/dot.svg";
import { ReactComponent as DownloadIcon } from "../../assets/download.svg";
import { ReactComponent as ExitIcon } from "../../assets/exit.svg";
import { ReactComponent as ExpandIcon } from "../../assets/expand.svg";
import { ReactComponent as FilterIcon } from "../../assets/filter.svg";
import { ReactComponent as LayerGroupIcon } from "../../assets/layer-group.svg";
import { ReactComponent as LeftIcon } from "../../assets/left.svg";
import { ReactComponent as MapPinIcon } from "../../assets/map-pin.svg";
import { ReactComponent as MinusIcon } from "../../assets/minus.svg";
import { ReactComponent as PencilIcon } from "../../assets/pencil.svg";
import { ReactComponent as PlusIcon } from "../../assets/plus.svg";
import { ReactComponent as RepeatIcon } from "../../assets/repeat.svg";
import { ReactComponent as RightSmallIcon } from "../../assets/right-small.svg";
import { ReactComponent as TargetIcon } from "../../assets/target.svg";
import { ReactComponent as TrashIcon } from "../../assets/trash.svg";
import { ReactComponent as UploadIcon } from "../../assets/upload.svg";
import TooltipContainer from "../TooltipContainer/TooltipContainer";

export type icons =
  | "angles-left"
  | "angles-right"
  | "arrow-right"
  | "balloon"
  | "calendar"
  | "camera"
  | "carret-left"
  | "carret-right"
  | "check"
  | "cross"
  | "dot"
  | "download"
  | "exit"
  | "expand"
  | "filter"
  | "layer-group"
  | "left"
  | "leftNav"
  | "map-pin"
  | "minus"
  | "pencil"
  | "plus"
  | "repeat"
  | "right"
  | "rightNav"
  | "target"
  | "trash"
  | "upload";
type sizes = "small" | "medium" | "large";

export const getIcon = (
  type: icons,
  size?: sizes,
  primary?: boolean,
  fill?: string,
  disabled?: boolean
) => {
  fill = disabled === true ? "white" : fill || (primary ? "white" : "#212529");
  const scale = {
    large: 1.2,
    medium: 1.1,
    small: 1,
  }[size || "small"] as number;
  switch (type) {
    case "angles-left":
      return <AnglesLeftIcon fill={fill} transform={`scale(${scale})`} />;
    case "angles-right":
      return <AnglesRightIcon fill={fill} transform={`scale(${scale})`} />;
    case "arrow-right":
      return <ArrowRightIcon fill={fill} transform={`scale(${scale})`} />;
    case "balloon":
      return <BalloonIcon fill={fill} transform={`scale(${scale})`} />;
    case "calendar":
      return <CalendarIcon fill={fill} transform={`scale(${scale})`} />;
    case "camera":
      return <CameraIcon fill={fill} transform={`scale(${scale})`} />;
    case "carret-left":
      return <CarretLeftIcon fill={fill} transform={`scale(${scale})`} />;
    case "carret-right":
      return <CarretRightIcon fill={fill} transform={`scale(${scale})`} />;
    case "check":
      return <CheckIcon fill={fill} transform={`scale(${scale})`} />;
    case "cross":
      return <CrossIcon fill={fill} transform={`scale(${scale})`} />;
    case "dot":
      return <DotIcon fill={fill} transform={`scale(${scale})`} />;
    case "download":
      return <DownloadIcon fill={fill} transform={`scale(${scale})`} />;
    case "exit":
      return <ExitIcon fill={fill} transform={`scale(${scale})`} />;
    case "expand":
      return <ExpandIcon fill={fill} transform={`scale(${scale})`} />;
    case "filter":
      return <FilterIcon fill={fill} transform={`scale(${scale})`} />;
    case "layer-group":
      return <LayerGroupIcon fill={fill} transform={`scale(${scale})`} />;
    case "left":
      return <LeftIcon fill={fill} transform={`scale(${scale})`} />;
    case "leftNav":
      return (
        <RightSmallIcon
          fill={fill}
          transform={`scale(${scale}), rotate(180)`}
        />
      );
    case "map-pin":
      return <MapPinIcon fill={fill} transform={`scale(${scale})`} />;
    case "minus":
      return <MinusIcon fill={fill} transform={`scale(${scale})`} />;
    case "pencil":
      return <PencilIcon fill={fill} transform={`scale(${scale})`} />;
    case "plus":
      return <PlusIcon fill={fill} transform={`scale(${scale})`} />;
    case "repeat":
      return <RepeatIcon fill={fill} transform={`scale(${scale})`} />;
    case "right":
      return (
        <LeftIcon fill={fill} transform={`scale(${scale}), rotate(180)`} />
      );
    case "rightNav":
      return <RightSmallIcon fill={fill} transform={`scale(${scale})`} />;
    case "target":
      return <TargetIcon fill={fill} transform={`scale(${scale})`} />;
    case "trash":
      return <TrashIcon fill={fill} transform={`scale(${scale})`} />;
    case "upload":
      return <UploadIcon fill={fill} transform={`scale(${scale})`} />;
  }
};

const getVariantStyles = (primary?: boolean) =>
  primary
    ? css`
        color: white;
        background-color: #309e5b;
        border: 1px solid #309e5b;
      `
    : css`
        color: #212529;
        background-color: #fff;
        border: 1px solid #e5e5e5;
      `;

const getSizeStyles = (size?: Props["size"]) => {
  switch (size) {
    case "small": {
      return css`
        width: 30px;
        height: 30px;
      `;
    }
    case "large": {
      return css`
        width: 50px;
        height: 50px;
      `;
    }
    default: {
      return css`
        width: 36px;
        height: 36px;
      `;
    }
  }
};

const disabledStyle = css`
  color: #212529;
  /* Mediumgrijs */
  background: #e5e5e5;

  /* Mediumgrijs */
  border: 1px solid #e5e5e5;
  border-radius: 5px;
`;

/**
 * Primary UI component for user interaction
 */
const StyledButton = styled.button<Props>`
  display: ${(props) => (props.inline ? css`inline-block` : css`flex`)};
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 5px;
  align-content: center;
  ${(props) => getVariantStyles(props.primary)}
  ${(props: Props) => getSizeStyles(props.size)}
  ${({ backgroundColor }) =>
    backgroundColor &&
    css`
      background-color: ${backgroundColor};
    `}
  ${({ borderColor }) =>
    borderColor &&
    css`
      border: 1px solid ${borderColor};
    `}
  ${(props) => (props.disabled ? disabledStyle : "")}}
`;

const Indicator = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  padding: 0.5em;
  color: white;
  display: flex;
  justify-content: center;
  font-size: 0.75em;
  background-color: orangered;
  border-radius: 50%;
  border: 1px solid white;
  align-items: center;
`;

export const IconButton = (props: Props) =>
  props.tooltip ? (
    <TooltipContainer tooltip={props.tooltip}>
      <StyledButton {...props} type="button" disabled={props.disabled === true}>
        {getIcon(
          props.icon,
          props.size,
          props.primary,
          props.iconColor,
          props.disabled
        )}
        {props.indicator && <Indicator />}
      </StyledButton>
    </TooltipContainer>
  ) : (
    <StyledButton {...props} type="button" disabled={props.disabled === true}>
      {getIcon(
        props.icon,
        props.size,
        props.primary,
        props.iconColor,
        props.disabled
      )}
      {props.indicator && <Indicator />}
    </StyledButton>
  );

export interface Props {
  /**
   * Is this the principal call to action on the page?
   */
  primary?: boolean;
  /**
   * What background color to use
   */
  iconColor?: string;
  /**
   * What background color to use
   */
  backgroundColor?: string;
  /**
   * What border color to use
   */
  borderColor?: string;
  /**
   * How large should the button be?
   */
  size?: sizes;
  /**
   * Icon to be displayed in the center
   */
  icon: icons;
  /**
   * Is the button disabled?
   */
  disabled?: boolean;
  /**
   * If a tooltip is provided, the button will show it when hovered over.
   */
  tooltip?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  inline?: boolean;
  indicator?: boolean;
}

IconButton.defaultProps = {
  iconColor: undefined,
  backgroundColor: undefined,
  primary: false,
  size: "small",
  indicator: false,
};

export default IconButton;
